import { useEffect } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import DynamicIcon from "../../routes/DynamicIcon";
import { LoadTags } from "../../utils/commonapis";
import { save } from "../../redux/slices/tagSlice";
import MENU from "./menu.json";
import "./styles.css";

function DashboardScreen() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const User = useSelector((state: any) => state.User.user);
  const Tags = useSelector((state: any) => state.Tags?.data);

  useEffect(() => {
    loadTags();
  }, []);

  const loadTags = async () => {
    const res: any = await LoadTags();
    dispatch(save(res));
  };

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return "Good Morning";
    if (hour < 18) return "Good Afternoon";
    return "Good Evening";
  };

  return (
    <Container fluid className="dashboard-container">
      <div className="dashboard-header">
        <div className="welcome-section">
          <div className="greeting-text">
            {getGreeting()}, {User?.username}
          </div>
          <div className="welcome-text">Welcome to Suprabhaatham Dashboard</div>
        </div>
        <div className="date-section">
          <div className="current-date">
            {new Date().toLocaleDateString("en-US", {
              weekday: "long",
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </div>
        </div>
      </div>

      {/* <div className="dashboard-grid">
        {MENU?.map((item: any, index: number) => {
          // Robustly parse user_access: handle pipe-separated string OR JSON array string
          let accessList: string[] = [];
          if (User?.user_access) {
            const ua = String(User.user_access).trim();
            if (ua.startsWith("[") && ua.endsWith("]")) {
              try {
                // Legacy JSON string format
                const parsed = JSON.parse(ua);
                if (Array.isArray(parsed)) accessList = parsed.map(String);
              } catch (e) {
                console.error("Failed to parse user_access JSON", e);
              }
            } else {
              // Pipe-separated format (standard)
              accessList = ua.split("|");
            }
          }

          return accessList.includes(String(item?.module_id)) ? (
            <div
              key={item.head}
              className="dashboard-card"
              onClick={() => navigate(item?.navigate)}
            >
              <div className="card-icon">
                <DynamicIcon name={item.icon} size={20} color={"#0055a6"} />
              </div>
              <div className="card-content">
                <div className="card-title">{item?.head}</div>
                <div className="card-description">{item?.description}</div>
              </div>
            </div>
          ) : null;
        })}
      </div> */}

      <div className="dashboard-grid">
        {MENU?.map((item: any) => {
          const accessList = String(User?.user_access || "").split("|");
          if (!accessList.includes(String(item?.module_id))) return null;

          return (
            <div
              key={item.head}
              className="dashboard-card"
              onClick={() => navigate(item?.navigate)}
            >
              <div className="card-icon">
                <DynamicIcon name={item.icon} size={20} color={"#0055a6"} />
              </div>
              <div className="card-content">
                <div className="card-title">{item?.head}</div>
                <div className="card-description">{item?.description}</div>
              </div>
            </div>
          );
        })}
      </div>
    </Container>
  );
}

export default DashboardScreen;
